import { AbstractControl, FormControl, FormGroup, ValidatorFn } from '@angular/forms';

export function specialSymbolsValidator(): ValidatorFn {
	const symbols = /[-!$%^#@&*()_+|~=`{}\[\]:";'<>?,.\/]/;
	return (control: AbstractControl): { [key: string]: any } | null => {
		return symbols.test(control.value) ? null : { specialSymbol: true };
	};
}

export function capitalLetterValidator(): ValidatorFn {
	const letter = /[A-Z]/;
	return (control: AbstractControl): { [key: string]: any } | null => {
		return letter.test(control.value) ? null : { capitalLetter: true };
	};
}

export function numberValidator(): ValidatorFn {
	const number = /\d/;
	return (control: AbstractControl): { [key: string]: any } | null => {
		return number.test(control.value) ? null : { number: true };
	};
}

export function passwordsMatchValidator() {
	return (form: FormGroup): any => {
		if (form.controls) {
			const password = form.get('password');
			const confirmPassword = form.get('confirmPassword');

			password.value === confirmPassword.value
				? confirmPassword.setErrors(null)
				: confirmPassword.setErrors({ passwordsMismatch: true });
		}
	};
}

export function inArray(included: boolean, array: string[]): ValidatorFn {
	// If the included flag is true, validator will trigger an error if the value is included in the array param.
	return (control: AbstractControl): { [key: string]: any } | null => {
		const value = control.value;

		if (!value) {
			return null;
		}

		if (included) {
			return array.includes(value) ? { inArray: true } : null;
		} else {
			return !array.includes(value) ? { inArray: true } : null;
		}
	};
}

export function duplicateControlError(field: string) {
	return (control: FormControl) => {
		let result = false;
		const group = control.parent as FormGroup;
		if (group) {
			const values = control.parent.parent.value.map((x) => x[field]);
			result = values.filter((x) => x.toLowerCase().trim() === control.value.toLowerCase().trim()).length > 1;
		}
		return result ? { error: 'duplicate' } : null;
	};
}
